<template>
  <div class="bg-white rounded-xl shadow-lg p-6">
    <h2 class="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
      <span>📈</span>
      Eficiencia Diaria
    </h2>

    <!-- Resumen -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <div class="bg-green-50 rounded-lg p-3 border border-green-200">
        <p class="text-sm text-gray-600 mb-1">Mejor Día</p>
        <p class="text-xl font-bold text-green-600">{{ eficiencia.mejor_dia.ventas }} ventas</p>
        <p class="text-xs text-gray-500">{{ formatearFecha(eficiencia.mejor_dia.fecha) }}</p>
      </div>
      <div class="bg-red-50 rounded-lg p-3 border border-red-200">
        <p class="text-sm text-gray-600 mb-1">Peor Día</p>
        <p class="text-xl font-bold text-red-600">{{ eficiencia.peor_dia.ventas }} ventas</p>
        <p class="text-xs text-gray-500">{{ formatearFecha(eficiencia.peor_dia.fecha) }}</p>
      </div>
      <div class="bg-blue-50 rounded-lg p-3 border border-blue-200">
        <p class="text-sm text-gray-600 mb-1">Promedio Diario</p>
        <p class="text-xl font-bold text-blue-600">{{ eficiencia.promedio_diario.ventas.toFixed(1) }} ventas</p>
        <p class="text-xs text-gray-500">{{ formatearMoneda(eficiencia.promedio_diario.valor) }}</p>
      </div>
    </div>

    <!-- Gráfico de Barras -->
    <div class="space-y-2 max-h-96 overflow-y-auto">
      <div
        v-for="dia in eficiencia.datos_diarios"
        :key="dia.fecha"
        class="flex items-center gap-3 hover:bg-gray-50 p-2 rounded transition-colors"
      >
        <div class="w-24 text-xs text-gray-600 flex-shrink-0">
          <div class="font-medium">{{ formatearFechaCorta(dia.fecha) }}</div>
          <div class="text-gray-500">{{ getDiaSemana(dia.dia_semana) }}</div>
        </div>
        <div class="flex-1">
          <div class="flex items-center gap-2 mb-1">
            <div class="flex-1 bg-gray-200 rounded-full h-6 relative overflow-hidden">
              <div 
                class="h-6 rounded-full transition-all duration-500 flex items-center justify-between px-2"
                :style="`width: ${getBarWidth(dia.ventas)}%; background-color: ${dia.color_indicador}`"
              >
                <span class="text-white text-xs font-semibold">{{ dia.ventas }} ventas</span>
                <span class="text-white text-xs">{{ dia.tasa_eficiencia.toFixed(0) }}%</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between text-xs text-gray-600">
            <span>💰 {{ formatearMoneda(dia.valor) }}</span>
            <span>✅ {{ dia.produccion_completa }} completados</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EficienciaDiaria',
  props: {
    eficiencia: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatearFecha(fecha) {
      const date = new Date(fecha + 'T00:00:00');
      return date.toLocaleDateString('es-MX', {
        month: 'short',
        day: 'numeric'
      });
    },
    formatearFechaCorta(fecha) {
      const date = new Date(fecha + 'T00:00:00');
      return date.toLocaleDateString('es-MX', {
        month: 'numeric',
        day: 'numeric'
      });
    },
    getDiaSemana(dia) {
      const dias = {
        'Monday': 'Lun',
        'Tuesday': 'Mar',
        'Wednesday': 'Mié',
        'Thursday': 'Jue',
        'Friday': 'Vie',
        'Saturday': 'Sáb',
        'Sunday': 'Dom'
      };
      return dias[dia] || dia;
    },
    formatearMoneda(valor) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(valor);
    },
    getBarWidth(ventas) {
      if (!this.eficiencia.datos_diarios) return 0;
      const max = Math.max(...this.eficiencia.datos_diarios.map(d => d.ventas));
      return (ventas / max) * 100;
    }
  }
};
</script>
